import * as React from "react";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as moment from "moment";

import store from "./store";

import Menu from "./components/structure/Menu";
import Nav from "./components/structure/Nav";

// get the screens
import Home from "./components/screens/Home";
import Terms from "./components/screens/Terms";
import Login from "./components/screens/Login/Login";
import Dashboard from "./components/screens/Dashboard/Dashboard";
import AttendanceModeStudentSelect from "./components/screens/AttendanceMode/AttendanceModeStudentSelect";
import AttendanceModeEventSelect from "./components/screens/AttendanceMode/AttendanceModeDayAndEventSelect";
import AttendanceModeStudentConfirm from "./components/screens/AttendanceMode/AttendanceModeStudentConfirm";


class App extends React.Component {

  public render() {
    return (
      <Provider store={store}>
        <Router>
          <Menu>
            <div className="container-fluid">
              <Nav />
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <main>
                      <Switch>
                        <Route exact={true} path="/" component={Home} />
                        <Route exact={true} path="/terms" component={Terms} />
                        <Route exact={true} path="/login" component={Login} />
                        <Route exact={true} path="/dashboard" component={Dashboard} />
                        <Route exact={true} path="/attendance" component={AttendanceModeEventSelect} />
                        <Route exact={true} path="/attendance/events/:eventId" component={AttendanceModeStudentSelect} />
                        <Route exact={true} path="/attendance/events/:eventId/users/:userId" component={AttendanceModeStudentConfirm} />

                      </Switch>
                    </main>
                  </div>
                </div>

                <footer>
                  <div className="row">
                    <div className="col-md-12" style={{ "textAlign": "center" }}>
                      <p className="small">Copyright 2010-{moment().format("YYYY")} <a href="https://www.kvsstechnologies.com" target="_new">KVSS Technologies, LLC</a> and <a target="_new" href="https://treelightsoftware.com">Treelight Software Inc</a></p>
                      <p className="small">Use of this application constitutes agreement with our <a href="/terms" target="_new">Terms of Service and Privacy Policy</a></p>
                    </div>
                  </div>
                </footer>
              </div>


              <ReduxToastr
                timeOut={3000}
                newestOnTop={false}
                preventDuplicates={true}
                position="top-center"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar={true} />
            </div>
          </Menu>
        </Router>
      </Provider>
    );
  }
}

export default App;
